/*
Loons Lab Sub title component
Developed By Roshan
Loons Lab
*/
import React, { Fragment, useState, Component } from "react";
import { Divider, Typography } from '@material-ui/core'
import PropTypes from "prop-types";

class SubTitle extends Component {
    static propTypes = {
        title: PropTypes.string,
        required: PropTypes.bool,
    };

    static defaultProps = {
        title: "",
        required: false
    };



    render() {
        const {
            title,
            required
        } = this.props;


        if(required === true){
            return (
                <div className='text-error flex'>
                    <Typography className=" text-gray font-semibold text-13 mt-2" style={{ lineHeight: '1', }}>{title}</Typography>
                    <p className="text-error font-bold" style={{ lineHeight: '0'}}>*</p>
                </div>
            );
        }else {
            return (
                <div className='text-error flex'>
                    <Typography className=" text-gray font-semibold text-13 mt-2 mb-2" style={{ lineHeight: '1', }}>{title}</Typography>
                        {/* <p className="text-error font-bold" style={{ lineHeight: '0'}}>*</p> */}
                </div>
            );
        }
    }
}

export default SubTitle;